import React, { useRef } from 'react';
import TechnicianImportModal from './component';

const TechnicianImportModalContainer = props => {
  const fileInputRef = useRef(null);

  const openFileInput = event => {
    event.preventDefault();
    fileInputRef.current.click();
  };

  return <TechnicianImportModal {...{ fileInputRef, openFileInput }} {...props} />;
};

export default TechnicianImportModalContainer;
